export const SUBSCRIPTION_DENIED = 'your subscription does not allow you to use this service';

export const getSubscriptionMessage = (user = {}, requestUrl = '', language = 'en') => {
  const { rate, payment_date: paymentDate, ban } = user || {};
  const paidUntil = Date.parse(paymentDate);
  if (ban || !Number.isFinite(paidUntil) || paidUntil <= Date.now()) return SUBSCRIPTION_DENIED;

  let included;
  if (rate === 'plo4' || rate === 'plo4annual') included = 'PLO 4';
  if (rate === 'plo5' || rate === 'plo5annual') included = 'PLO 5';
  const current = requestUrl.startsWith('/5card/') ? 'PLO 5' : 'PLO 4';
  if (!included || included === current) return SUBSCRIPTION_DENIED;

  if (language.toLowerCase().startsWith('ru')) {
    return `Ваша подписка включает ${included}. Сейчас вы просматриваете ${current}. Переключитесь на ${included}, чтобы изучать игру и тренироваться по вашей подписке.`;
  }
  return `Your subscription includes ${included}. You’re currently viewing ${current}. Switch to ${included} to study and train with your subscription.`;
};
